module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-9-c47dcee86e86269d342f9521031ac839.svg";